import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { office } from "../interface/officedetails.interface";
import { useSelector } from 'react-redux';
function Footer() {
    const officeDetails: { office: office[], headoffice: office[] } = useSelector(
        (state: any) => state.home.officeDetails
    );
    let headOffice: office | undefined;

    if (
        officeDetails &&
        officeDetails.headoffice &&
        officeDetails.headoffice.length > 0
    ) {
        headOffice = officeDetails.headoffice[0];
    }
    return (
        <>
            <footer className="blackBg py-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12 footerAddressHldr">
                            <div className="footerAddress">
                                {headOffice && (
                                    <>
                                        <h3>{headOffice.officeName}</h3>
                                        <p className="mb-3 d-flex"><i className="fa fa-map-marker me-2"></i> {headOffice.addressLine1}<br />{headOffice.addressLine2} <br />{headOffice.cities} - {headOffice.pincode}, {headOffice.state} India</p>
                                        <p><a href="mailto:waltz@jbglass.in"><i className="fa fa-envelope me-1"></i> {headOffice.emailAddress}</a></p>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="footerLogo">
                                <img src="/assets/images/logo.webp" alt="/assets/images/logo.webp" />
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <section className="copyRightWrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            &copy; {new Date().getFullYear()} JB Glass. All rights reserved.
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-6 policyHldr">
                            {/* <a href="/privacy-policy">Privacy Policy</a> <a href="/terms-and-conditions">Terms Of Use</a> */}
                            <Link to="/privacy-policy">Privacy Policy</Link><Link to="/terms-and-conditions">Terms Of Use</Link>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Footer